<template>
    <div class="form__container" :id="'input_' + inputData.id">
        <label :for="'inputField_' + inputData.id" class="form__heading">
            <span>{{ inputData.name }}</span>
            <required-indicator :inputData="inputData"></required-indicator>
        </label>
        <div class="form__input-container">
            <div class="form__inputs-box">
                <input class="form__input form__input--radio"
                    type="radio"
                    :name="'input_' + inputData.id" 
                    :id="'inputField_' + inputData.id + '_norwegian'"
                    :value="true"
                    :required="inputData.required"
                    :class="inputData.error ? 'form__input--error' : ''"
                    v-model="isTrue"
                    @click="updateNorwegianCitizen">    
                <label :for="'inputField_' + inputData.id + '_norwegian'" class="form__label form__label--radio">{{ $t('yes')}}</label>
            </div>
            <div class="form__inputs-box">
                <input class="form__input form__input--radio"
                    type="radio"
                    :name="'input_' + inputData.id" 
                    :id="'inputField_' + inputData.id + '_other'"
                    :value="false"
                    :required="inputData.required"
                    :class="inputData.error ? 'form__input--error' : ''"
                    v-model="isTrue">    
                <label :for="'inputField_' + inputData.id + '_other'" class="form__label form__label--radio">{{ $t('no')}}</label>
            </div>
        </div>
        <label v-if="inputData.desc && isTrue" class="form__heading form__heading--autocomplete">
            <span>{{ inputData.desc }}</span>
        </label>
        <div v-if="isTrue" class="form__input-container">
            <textarea class="form__input form__input--textarea" 
                type="textarea" 
                :id="'inputField_' + inputData.id"
                :name="inputData.id"
                :required="inputData.required"
                :class="inputData.error ? 'form__input--error' : ''"
                v-model="inputValue"
                :maxlength="maxLength"
            ></textarea>
            <div class="form__input-maxlength">{{ $t('max')}} {{ charactersLeft }} {{ $t('characters')}}</div>
        </div>
        <div class="form__error" :id="'error_' + inputData.id" v-if="inputData.error" role="alert">{{ inputData.error }}</div>
        <div>
            <span class="form__explanation" v-if="inputData.explanation">{{ inputData.explanation }}</span>
        </div>
    </div>
</template>

<script>
import RequiredIndicator from './RequiredIndicator.vue';
import { useI18n } from 'vue-i18n'
import { watch, ref, computed } from 'vue';
import { countCharacters } from '../../components/countCharacters.js';

export default {
    props: ['inputData'],
    emits: ['inputValue'],
    components: {
        'required-indicator': RequiredIndicator
    },
    setup(props, ctx){
        const { t, locale } = useI18n();

        // Handle incoming data.
        watch(props.inputData, (inputData) => {
            if(inputData.value && inputData.value == t('no')){
                isTrue.value = false;
            } else {
                inputValue.value = inputData.value ? inputData.value : "";
            }
            
        });

        // inputValue
        const inputValue = ref(props.inputData.value ? props.inputData.value : '');
        watch(inputValue, (value) => {
            ctx.emit('inputValue', props.inputData.id, inputValue.value);
        });

        // isTrue
        const isTrue = ref(true);
        watch(isTrue, (value) => {
            if(!value){
                inputValue.value = t('no');
            } else {
                inputValue.value = "";
            }
            ctx.emit('inputValue', props.inputData.id, inputValue.value);

        });

        // Characters left in field
        const maxLength = ref(2000);
        const charactersLeft = computed(() => {
            return maxLength.value - countCharacters(inputValue.value);
        });

        // TODO: This is a hack to set the default value to false if no value is set.
        setTimeout(() => {
            if(!props.inputData.value){
                isTrue.value = false;
            }
        }, 1000);

        return {
            inputValue,
            isTrue,
            maxLength,
            charactersLeft
        }
    }
}
</script>